<template>
  <v-menu
    v-model="dialog"
    :close-on-content-click="false"
    rounded="lg"
    offset-y
    max-width="250"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="teal"
        class="white--text"
        :disabled="disabled"
        v-on="on"
        v-bind="attrs"
      >
        <v-icon left>mdi-check</v-icon> Selecionar</v-btn
      >
    </template>
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <v-form ref="form">
              <v-text-field
                label="Qtde carregar nesta caixa"
                v-mask="'#####'"
                suffix="Kgs"
                v-model="qtdeCarregarModel"
                autofocus
                outlined
                v-if="caixaSelec > 0"                
                :rules="[
                  (v) => !!v || 'Quantidade precisa ser informada',
                  (v) =>
                    (v <= item.saldo && v <= item.capac_cx) ||
                    'Quantidade informada excede o permitido',
                  (v) =>
                    v >= configuracoes.dados.min_kgs_carreg ||
                    `Informe no mínimo ${configuracoes.dados.min_kgs_carreg} Kgs`,
                ]"
              ></v-text-field>
              <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-subtitle>Qtde carregar nesta caixa</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-bold">{{qtdeCarregarModel}} Kgs</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
            </v-form>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="6">
            <v-btn
              color="success"
              rounded
              text
              block
              @click="confirmar()"
              class="font-weight-bold"
              :loading="confirmando"
              >Confirmar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              color="secondary"
              rounded
              @click="dialog = false"
              block
              text
              class="font-weight-bold"
              :disabled="confirmando"
              >Cancelar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    item: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
  },
  watch: {
    dialog: function (open) {
      if (open) {
        this.setQtdeCarregar(
          this.item.saldo > this.item.capac_cx
            ? this.item.capac_cx
            : this.item.saldo
        );

        this.items.push({ label: "Pedido", value: this.item.nr_pedido }),
          this.items.push({ label: "Cliente", value: this.item.nome_cliente }),
          this.items.push({
            label: "Produto",
            value: `${this.item.produto} - ${this.item.embalagem}`,
          });
        this.items.push({ label: "Caixa", value: this.caixaSelec }),
          this.items.push({
            label: "Capacidade da caixa",
            value: `${this.item.capac_cx} Kgs`,
          });
      }
    },
  },
  computed: {
    ...mapState("formacaoCarga", [
      "caixaSelec",
      "qtde_carregar",
      "configuracoes",
    ]),
    qtdeCarregarModel: {
      get: function () {
        return this.qtde_carregar;
      },
      set: function (value) {
        this.setQtdeCarregar(value);
      },
    },
  },
  data: () => ({
    dialog: false,
    items: [],
    confirmando: false
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setQtdeCarregar"]),
    ...mapActions("formacaoCarga", ["selecionarProdutoCaixa"]),
    confirmar() {
      if (this.$refs.form.validate()) {
        if (
          this.qtde_carregar == undefined ||
          isNaN(this.qtde_carregar) ||
          parseInt(this.qtde_carregar) <= 0 ||
          parseInt(this.qtde_carregar) > this.item.capac_cx ||
          parseInt(this.qtde_carregar) > this.item.saldo
        ) {
          this.$toasted.error("Informe corretamente a quantidade!");
          return;
        }
        this.confirmando = true

        this.selecionarProdutoCaixa(this.item);        
        this.$router.go(-1)
      }
    },
  },
};
</script>

<style>
</style>